// removed by extract-text-webpack-plugin
module.exports = {"Rooms":"_19B04foY3gJmzJOP5OZcau"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Rooms/Rooms.css
// module id = 250
// module chunks = 0